import { createSelector } from 'reselect';
import Constants from './constants';
import { InviteMapper, StatusFilterMapper, TeamsFilterMapper } from '../../../Pages/Users/constants';

const STATE_KEY_NAME = Constants.MODULE_NAME;

const stateSelector = (state) => state[STATE_KEY_NAME];
const allStateSelector = (state) => state;

const usageDataSelector = createSelector(stateSelector, (state) => state.usageData);
const userFilterSelector = createSelector(stateSelector, (state) => state.userFilter);
const teamsFilterSelector = createSelector(stateSelector, (state) => state.teamsFilter);
const statusFilterSelector = createSelector(stateSelector, (state) => state.statusFilter);
const timeFilterSelector = createSelector(stateSelector, (state) => state.timeFilter);
const usageAnalyticsDataSelector = createSelector(stateSelector, (state) => state.usageAnalyticsData);
const isLoadingUsageSelector = createSelector(stateSelector, (state) => state.isLoading);
const exportRequestIdSelector = createSelector(stateSelector, (state) => state.exportRequestId);
const isExportRequestReadySelector = createSelector(stateSelector, (state) => state.isExportRequestReady);
const isExportLoadingSelector = createSelector(stateSelector, (state) => state.isExportLoading);
const filteredUsageDataSelector = createSelector(allStateSelector, (state) => {
  const users = state.users.orgUsers;
  const usage = state.usage;
  let data = users || [];
  data = data.filter((user) => user.status.type === StatusFilterMapper.ACTIVE);
  data = data.map((user) => {
    const userUsageData = usage.usageData?.find((u) => u.email === user.email);

    return {
      email: user.email,
      first_name: user.first_name,
      last_name: user.last_name,
      assigned: user.assigned_to_search ? 'Assigned' : 'Not assigned',
      searches: userUsageData ? userUsageData.searches : '0',
      status: user.status,
      teams: user.teams,
    };
  });
  const removedUsersUsage = usage.usageData?.filter((user) => !users.map((u) => u.email).includes(user.email));
  const removedUsers = removedUsersUsage?.map((user) => {
    return {
      email: user.email,
      first_name: user.first_name,
      last_name: user.last_name,
      assigned: 'Removed',
      status: { type: 'removed' },
      searches: user.searches,
    };
  });
  data = data.concat(removedUsers);
  if (usage.userFilter) {
    data = data.filter((user) => {
      const fullName = `${user.first_name} ${user.last_name}`.toLowerCase();
      return fullName.includes(usage.userFilter.toLowerCase()) || user.email.includes(usage.userFilter.toLowerCase());
    });
  }
  if (usage.statusFilter) {
    if (usage.statusFilter === StatusFilterMapper.ASSIGNED) {
      data = data.filter((user) => user.status.type === StatusFilterMapper.ACTIVE && user.assigned === 'Assigned');
    }
    if (usage.statusFilter === StatusFilterMapper.UNASSIGNED) {
      data = data.filter((user) => user.status.type === StatusFilterMapper.ACTIVE && user.assigned === 'Not assigned');
    }
    if (usage.statusFilter === StatusFilterMapper.REMOVED) {
      data = data.filter((user) => user.assigned === 'Removed');
    }
    if (usage.statusFilter === StatusFilterMapper.PENDING) {
      data = data.filter(
        (user) =>
          user.status.invite_status === InviteMapper.INVITE_SENT || user.status.type === StatusFilterMapper.PENDING,
      );
    }
  }
  if (usage.teamsFilter) {
    if (usage.teamsFilter === TeamsFilterMapper.UNASSIGNED) {
      data = data.filter((user) => user.teams?.length === 0);
    }
    if (usage.teamsFilter !== TeamsFilterMapper.ALL && usage.teamsFilter !== TeamsFilterMapper.UNASSIGNED) {
      data = data.filter((user) => user.teams?.map((team) => team.name).includes(usage.teamsFilter));
    }
  }
  data.sort((a, b) => {
    if (a.searches > b.searches) {
      return -1;
    }
    if (a.searches < b.searches) {
      return 1;
    }
    return 0;
  });
  return data;
});

export const UsageSelectors = {
  usageDataSelector,
  userFilterSelector,
  teamsFilterSelector,
  statusFilterSelector,
  timeFilterSelector,
  usageAnalyticsDataSelector,
  isLoadingUsageSelector,
  exportRequestIdSelector,
  isExportRequestReadySelector,
  filteredUsageDataSelector,
  isExportLoadingSelector,
};
